import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const InfoToastContent = ({ title, message }) => (
  <div style={{ position: 'relative' }}>
    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{title}</div>
    <div>{message}</div>
  </div>
);

InfoToastContent.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export const showErrorToast = (message) => {
  toast.error(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      bottom: '80px',
      right: '20px',
    },
  });
};

export const showSuccessToast = (message) => {
  toast.success(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      bottom: '80px',
      right: '20px',
    },
  });
};

export const showInfoToast = (title, message, onClick) => {
  const toastId = toast.info(
    <InfoToastContent
      title={title}
      message={message}
      closeToast={() => toast.dismiss(toastId)}
    />,
    {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false, // Disable default click behavior
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClick, // Custom click handler for toast container
      style: {
        top: '80px',
        right: '20px',
      },
    },
  );

  return toastId;
};
